import { render, staticRenderFns } from "./ProntuarioPainel.vue?vue&type=template&id=435bbe55&"
import script from "./ProntuarioPainel.vue?vue&type=script&lang=js&"
export * from "./ProntuarioPainel.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioPainel.vue?vue&type=style&index=0&id=435bbe55&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports